import React, { useState, useEffect, useMemo } from 'react';
import { Box, Paper, Text, Switch, Group } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import { useQuery, useLazyQuery } from '@apollo/client';

import '@fontsource/orbitron/700.css'; // For bold weight

import PurchasingDepartmentPerformancePanel from './PurchasingDepartmentPerformancePanel';

// Import your GraphQL query
import { GET_DAILY_SALESPERSON_SALES_PRODUCTION, GET_DAILY_SALESPERSON_PRICING_PRODUCTION, GET_ASSIGNED_ACCOUNTS } from '../../../../queries'; // Adjust the path as needed

import PurchasingDepartmentScorecardTabSet from './PurchasingDepartmentScorecardTabSet';

const PurchasingDepartmentScorecard = () => {
    const [onlyPurchasingWarehouses, setOnlyPurchasingWarehouses] = useState(true);
    
    const warehouseFilter = onlyPurchasingWarehouses ? 'IN' : 'OUT';

    return (
        <Paper>
            <Group justify="space-between" align="center" mb="md">
                <Text 
                    size="xl"
                    fw={700}
                    c="#FDB813"
                    style={{ 
                        fontFamily: 'Orbitron, sans-serif',
                        fontStyle: 'italic'
                    }}
                    component="h1"
                >
                    Purchasing Department Scorecard
                </Text>
                
                <Switch
                    label="Only purchasing warehouses"
                    checked={onlyPurchasingWarehouses}
                    onChange={(event) => setOnlyPurchasingWarehouses(event.currentTarget.checked)}
                    size="sm"
                />
            </Group>
            
            <Box>
                
                <PurchasingDepartmentScorecardTabSet filter={warehouseFilter} />
            </Box>
        </Paper>
    );
};

export default PurchasingDepartmentScorecard;